import z from 'zod';
import { OnboardingFormFields } from '@Types/index.ts';
import { getIsDateValid, getParsedDateAsISO } from '@Services/utils/utils.ts';
import { differenceInYears } from 'date-fns';
import { t } from 'i18next';

export const birthDateSchema = z.object({
  [OnboardingFormFields.DATE_OF_BIRTH]: z
    .string()
    .min(1, t('enErrors:dateOfBirthRequired'))
    .refine(
      (rawDate) => {
        const cleanedDate = rawDate.replace(/\//g, '').replace(/ /g, '');
        return cleanedDate.length === 8;
      },
      { message: t('enErrors:dateOfBirth') }
    )
    .refine(
      (rawDate) => getIsDateValid(rawDate),

      { message: t('enErrors:dateOfBirthInvalid') }
    )
    .refine(
      (rawDate) => {
        if (!getIsDateValid(rawDate)) return false; // We need to check for validity so we can avoid an error in getParsedDateAsISO
        const parsedDate = getParsedDateAsISO(rawDate);
        return differenceInYears(new Date(), new Date(parsedDate)) >= 18;
      },
      { message: t('enErrors:olderThen18') }
    )
    .refine(
      (rawDate) => {
        if (!getIsDateValid(rawDate)) return false;
        const parsedDate = getParsedDateAsISO(rawDate);
        return differenceInYears(new Date(), new Date(parsedDate)) <= 120;
      },
      { message: t('enErrors:dateOfBirthInvalid') }
    ),
});
